// extracted by mini-css-extract-plugin
export default {"form":"VideoForm_form__OspiX","divTipo":"VideoForm_divTipo__UcbzB","mensagem":"VideoForm_mensagem__PXAAs"};